import { Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import RenderSurveyTable from "./RenderSurveyTable";
import { surveyTab3Fields, surveyTab3Heading } from "./surveyUtils";
import CustomButton from "../../../../components/common/button/CustomButton";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { updateSurveyTabAction } from "../../../../store/reducers/leadSurveySlice";

const SurveyedItemTabForm: FC<any> = ({
  data = {},
  elementId = 0,
  surveyForm = null,
  setSurveyForm = () => {},
  error = null,
  setError = () => {},
  tabChangeHandler = () => {},
  linkedItems = [],
  tabValidator = () => {},
  setIsValueChanged = () => {},
  disabledAction = false,
}) => {
  const { leadDetails } = useSelector((state: any) => state.lead);
  const { surveyedItems } = useSelector((state: any) => state.leadSurvey);

  const dispatch = useDispatch();

    const [materialsForm, setMaterialsForm]: any = useState(null);
  const [materialsChanged, setMaterialsChanged] = useState(false);
 
  const materialsEntry = surveyedItems?.list?.find(
    (ele: any) => ele?.name === "Materials"
  );

  useEffect(() => {
    if (data) {
      let createList: any = [];
      let order = 1;
      if (surveyedItems) {
        // createList = surveyedItems?.list?.[elementId]?.items || []
        const filtered = surveyedItems?.list.find(
          (ele: any) => ele?.name === data?.room
        );
       
        filtered?.items &&
          filtered?.items?.map((ele: any, idx: any) => {
            createList.push({
              ...ele,
              sortOrder: order,
            });
            order++;
          });
      }
      
      // Find the room that matches `data.room`
      const filteredRoom = surveyedItems?.list?.find(
        (ele: any) => ele?.name === data?.room
      );
      // Check if the name is 'Materials' to decide on filtering
      console.log("createList",createList);
      const filteredList =
        filteredRoom?.name === "Materials"
          ? createList.filter((item: any) =>  Number(item.quantity || 0) > 0) // No filtering for Materials
          : createList.filter((item: any) => item.quantity !== 0);


      console.log("createList -filteredList",filteredList);
      // Set the filtered or unfiltered list to state
      setSurveyForm(filteredList);
    }
  }, [data, surveyedItems, elementId]); //selectedLeadEstimate, show

    // Keep a separate, editable local copy of the Materials items so editing
  // them here never touches the current room's surveyForm. Each item is
  // cloned individually (not just the array) because materialsEntry.items
  // comes straight from Redux state, which Immer deep-freezes in
  // development - mutating those objects directly would throw "Cannot
  // assign to read only property".
  useEffect(() => {
    setMaterialsForm(
      materialsEntry?.items
        ? materialsEntry.items
            .filter((item: any) => Number(item?.quantity || 0) > 0)
            .map((item: any) => ({ ...item }))
        : []
    );
  }, [materialsEntry]);
  
  const onChangeAction = (event: any, index?: any, valueFormat?: any) => {
    const { id, value, checked } = event.target;
    const cloneItem = [...surveyForm];
    if (cloneItem?.[index]) {
      let obj: any = {};
      if (
        id === "isLeave" ||
        id === "isWeee" ||
        id === "isCust" ||
        id === "isClear"
      ) {
        obj = {
          ...cloneItem[index],
          isLeave: false,
          isWeee: false,
          isCust: false,
          isClear: false,
          [id]: checked,
        };
      } else {
        obj = {
          ...cloneItem[index],
          [id]:
            valueFormat === "number" && value
              ? Number(value)
              : valueFormat === "price" && value
                ? value
                : value,
        };
      }
      cloneItem[index] = {
        ...obj,
      };
    }
    setIsValueChanged(true);
    setSurveyForm(cloneItem);
  };

  const onBlurAction = (event: any, index?: any, valueFormat?: any) => {
    const { id, value, checked } = event.target;

    const cloneItem = [...surveyForm];
    if (cloneItem?.[index]) {
      let obj: any = {};
      if (
        id === "isLeave" ||
        id === "isWeee" ||
        id === "isCust" ||
        id === "isClear"
      ) {
        obj = {
          ...cloneItem[index],
          isLeave: false,
          isWeee: false,
          isCust: false,
          isClear: false,
          [id]: checked,
        };
      } else {
        obj = {
          ...cloneItem[index],
          [id]:
            valueFormat === "number"
              ? value
                ? Number(value)
                : 0
              : valueFormat === "price"
                ? value
                  ? Math.round(value * 100) / 100
                  : 0
                : value,
        };
      }
      cloneItem[index] = {
        ...obj,
      };
    }
    setSurveyForm(cloneItem);
  };
  const submitHandler = () => {
    const { isError, localError }: any = tabValidator(surveyForm);
    setError(localError);
    if (!isError) {
      dispatch(
        updateSurveyTabAction({
          tab: "tab3",
          surveyId: leadDetails?.lead?.survey_id,
          data: {
            name: data?.room,
            items: surveyForm,
          },
        })
      );
      setIsValueChanged(false);
    }
  };

  // Materials list - shown editable in every room (except the "Materials"
  // room itself, if that's ever rendered directly) so users can see and
  // update material items regardless of which room tab is selected.
  // Changes save back to the "Materials" room specifically, never to the
  // currently selected room.
  const materialsItems = materialsForm || [];
  const showMaterialsSection =
    data?.room !== "Materials" && materialsItems?.length > 0;
 
  const onChangeMaterialsAction = (event: any, index?: any, valueFormat?: any) => {
    const { id, value, checked } = event.target;
 
    setMaterialsForm((prevForm: any) => {
      const cloneItem = [...(prevForm || [])];
      if (cloneItem?.[index]) {
        let obj: any = {};
        if (id === "isLeave" || id === "isWeee" || id === "isCust" || id === "isClear") {
          obj = {
            ...cloneItem[index],
            isLeave: false,
            isWeee: false,
            isCust: false,
            isClear: false,
            [id]: checked,
          };
        } else {
          obj = {
            ...cloneItem[index],
            [id]:
              valueFormat === "number" && value ? Number(value) :
              valueFormat === "price" && value ? value :
              value,
          };
        }
        cloneItem[index] = { ...obj };
      }
      return cloneItem;
    });
 
    setMaterialsChanged(true);
  }

  const onBlurMaterialsAction = (event: any, index?: any, valueFormat?: any) => {
    const { id, value, checked } = event.target;
 
    setMaterialsForm((prevForm: any) => {
      const cloneItem = [...(prevForm || [])];
      if (cloneItem?.[index]) {
        let obj: any = {};
        if (id === "isLeave" || id === "isWeee" || id === "isCust" || id === "isClear") {
          obj = {
            ...cloneItem[index],
            isLeave: false,
            isWeee: false,
            isCust: false,
            isClear: false,
            [id]: checked,
          };
        } else {
          obj = {
            ...cloneItem[index],
            [id]:
              valueFormat === "number" ? (value ? Number(value) : 0) :
              valueFormat === "price" ? (value ? Math.round(value * 100) / 100 : 0) :
              value,
          };
        }
        cloneItem[index] = { ...obj };
      }
      return cloneItem;
    });
  };
 
  const submitMaterialsHandler = () => {
    const { isError }: any = tabValidator(materialsForm);
    if (!isError) {
      const materialsPayload = materialsForm?.filter((item: any) => item?.item);
      dispatch(
        updateSurveyTabAction({
          tab: "tab3",
          surveyId: leadDetails?.lead?.survey_id,
          data: {
            name: "Materials",
            roomName: materialsEntry?.roomName || "Materials",
            items: materialsPayload,
          },
        })
      );
      setMaterialsChanged(false);
    }
  };

  return (
    <>
    <section style={{ backgroundColor: "#FFF", padding: "0px",border:'1px solid #CFCFCF',borderRadius:'5px' }}>
        <RenderSurveyTable
          {...{
            surveyForm,
            onChangeAction,
            onBlurAction,
            error,
            tableHeadding: surveyTab3Heading,
            tableContent: surveyForm,
            fields: surveyTab3Fields,
            linkedItems: linkedItems,
            disabledAction: disabledAction,
            isMaterialsTab: data?.room === "Materials",
            isResourcesTab: data?.room ==="Resources",
            keyName: data?.room?.replace(" ", ""),
          }}
        />
        <br />
        {/* {!disabledAction && (
          <CustomButton title="Save" onClick={() => submitHandler()} />
        )} */}

         {showMaterialsSection && (
              <>
                <Typography
                  sx={{
                    fontWeight: 600,
                    color: "#0F906E",
                    fontSize: "16px",
                    padding: "10px 10px 0px 10px",
                  }}
                >
                  Materials
                </Typography>
                <RenderSurveyTable {...{
                  surveyForm: materialsItems,
                  onChangeAction: onChangeMaterialsAction,
                  onBlurAction: onBlurMaterialsAction,
                  error: null,
                  tableHeadding: surveyTab3Heading,
                  tableContent: materialsItems,
                  fields: surveyTab3Fields,
                   linkedItems: linkedItems,
                  disabledAction: disabledAction,
                  isMaterialsTab: true,
                  keyName: "Materials"
                }} />
                {/* {!disabledAction && materialsChanged && (
                  <CustomButton
                    title="Save Materials"
                    onClick={() => submitMaterialsHandler()}
                    style={{ margin: "4px 10px" }}
                  />
                )} */}
              </>
            )}
      </section>
    </>
  );
};

export default SurveyedItemTabForm;
